import { render, staticRenderFns } from "./ManageModels.vue?vue&type=template&id=5b89ec64&scoped=true"
import script from "./ManageModels.vue?vue&type=script&lang=js"
export * from "./ManageModels.vue?vue&type=script&lang=js"
import style0 from "./ManageModels.vue?vue&type=style&index=0&id=5b89ec64&prod&lang=css"
import style1 from "./ManageModels.vue?vue&type=style&index=1&id=5b89ec64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b89ec64",
  null
  
)

export default component.exports